// extracted by mini-css-extract-plugin
export default {"container":"TgISbN","active":"uL8dDL","placeholder-shimmer":"VOknIm","placeholderShimmer":"VOknIm","universal":"_Ylg0k","dark":"_BRG8E","light":"D1y5OO"};